/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { SwipeableList, Type as ListType } from 'react-swipeable-list';
import { DenominationFooter } from 'components/pages/collection';
import { NoData } from 'components';
import { Box } from 'atoms';
// import { InvoiceSwipeWrapper } from 'components/pages/collection/swipe-invoices/InvoiceCardWrapper';
import { SalesInvoiceSwipeWrapper } from 'components/pages/collection-app/swiple-invoiceCard';
import AddInvoices from 'components/pages/collection-app/AddInvoices';

const Cards = styled(Box)`
	max-height: 75vh;
	padding-bottom: 2rem;
	overflow: auto;
`;

export default function SalesmanMyCollection() {
	const { SalesInvoices = [], SalesInvoicesFiltered = [] } = useSelector(
		(state) => state.salesman
	);

	return (
		<>
			{SalesInvoices?.length === 0 ? (
				<>
					<NoData>Invoice Not Available</NoData>
					<AddInvoices />
				</>
			) : (
				<Cards>
					{SalesInvoicesFiltered?.length > 0 ? (
						<>
							<SwipeableList fullSwipe={false} threshold={0.25} type={ListType.IOS}>
								{SalesInvoicesFiltered?.map((invoice) => (
									<SalesInvoiceSwipeWrapper key={invoice?.id} invoice={invoice} />
								))}
							</SwipeableList>
							<AddInvoices />
						</>
					) : (
						<NoData>Invoice Not Found</NoData>
					)}

					<DenominationFooter />
				</Cards>
			)}
		</>
	);
}
